import { ReactNode } from "react";
import Modal, { ModalProps } from "../modal";
import { ModalActionButton } from "../modal/modal-view";

export interface ConfirmActionButton extends ModalActionButton {
  // disabled?: false;
}
export interface ConfirmModalConfirmStateProps {
  /**
   * confirmation state
   */
  confirm: boolean;
  /**
   * confirmation state
   */
  onUpdateConfirm: (b: boolean) => void;
}
export interface ConfirmModalProps
  extends ModalProps,
    ConfirmModalConfirmStateProps {
  /**
   * The title of the modal dialog
   */
  confirmTitle: ReactNode;
  /**
   * The content of the modal dialog
   */
  confirmContent: ReactNode | (() => ReactNode);
  /**
   * confirm handler, returns the state to set
   * @param b
   */
  onConfirm?: (b: boolean) => Promise<boolean>;

  acceptButton: ConfirmActionButton | undefined;
  cancelButton: ConfirmActionButton | undefined;
  skipConfirm?: boolean;
}

function ConfirmModal(props: ConfirmModalProps) {
  const {
    skipConfirm,
    children,
    confirm,
    title,
    confirmTitle,
    confirmContent,
    acceptButton,
    primaryButton,
    cancelButton,
    secondaryButton,
    onPrimaryAction,
    onSecondaryAction,
    onUpdateConfirm,
    ...other
  } = props;

  const mProps = {
    title: confirm ? confirmTitle : title,
    children: children,
    primaryButton: confirm ? acceptButton : primaryButton,
    secondaryButton: confirm ? cancelButton : secondaryButton,
    onPrimaryAction:
      !confirm && !skipConfirm
        ? () => {
            onUpdateConfirm(true);
          }
        : onPrimaryAction,
    onSecondaryAction:
      confirm && !skipConfirm
        ? () => {
            onUpdateConfirm(false);
          }
        : onSecondaryAction,
    ...other,
  };
  if (confirm && typeof confirmContent === "function") {
    mProps.children = confirmContent();
  } else if (confirm) {
    mProps.children = confirmContent as ReactNode;
  }
  return <Modal {...mProps} />;
}
export default ConfirmModal;
